// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_authentication_authentication_module_ts":"60089488a298a4f5","node_modules_echarts_index_js":"527ba84c3198a9a5"}[chunkId] + ".js";
};